var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-textarea',{attrs:{"value":_vm.value,"label":_vm.label,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"error-messages":_vm.errorLabel,"rules":_vm.rules,"row":_vm.row,"helper-text":_vm.helperMessage,"name":_vm.name,"outlined":"","dense":"","hide-details":""},on:{"input":e => _vm.$emit('input', e)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }